import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.InvestmentPeersEdit })));

export default { edit };
